import { render, staticRenderFns } from "./BuildingFloorSetting.vue?vue&type=template&id=2058957b&"
import script from "./BuildingFloorSetting.vue?vue&type=script&lang=js&"
export * from "./BuildingFloorSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports